<p-toast [key]="toastKey"> </p-toast>
<div class="employeeTrainingPlan">
    <div class="flex card-container">
      <div class="label-wrapper">
        <label>User</label>
      </div>
      <div class="flex flex-row scope-wrapper">
      <div class="tree-wrapper">
        <p-treeSelect
          selectionMode="single"
          class="w-full"
          [(ngModel)]="selectedUser"
          [options]="userTreeData"
          [style]="{ 'width': '100%' }"
          [ngClass]="{'red': userWithTerminatedStatusSelected}"
          (onNodeSelect)="handleTreeSelectChange($event)"
          [filter]="true"
          ></p-treeSelect>
      </div>
      
      <div class="flex grid" [ngClass]="{ 'enabled-gridClass': selectedUser }">
        <div class="col-grow"></div>
        <div class="col-fixed">
            <bpt-file-upload
                [uploadFiles]="uploadSucceeds"
                [fileTypes]="''"
                [maxSize]="maxFileSize"
                [disabled]="!userSelected"
                [fileLimit]="userProfileAttachmentMaxLimit">
            </bpt-file-upload>
        </div>
        <div class="col-fixed editButton">
            <p-button
                styleClass="p-button-outlined"
                icon="fa fa-pen"
                id="editUserProfileBtn"
                class="edit-User-Profile-Button"
                pTooltip="Edit User Profile"
                tooltipPosition="left"
                iconPos="left"
                [disabled]="!userSelected"
                (onClick)="editUserProfile()">
            </p-button>
        </div>
    </div>
      </div>
      
    </div>
    <div *ngIf="selectedUser != null">
    <app-user-profile-details [userProfile]="userProfile" [treeData]="treeData"></app-user-profile-details>
    </div>
<app-user-profile-slider [isUserProfileSliderOpen]="isUserProfileSliderOpen" [userPUIDForEdit]="userPUIDForEdit" (closeUserProfileSlider)="reloadUserData()"> </app-user-profile-slider>
</div>
